import React, { Component } from 'react'
import styled from 'styled-components'
import { Container } from 'reactstrap'

import AgriculturalStudies from '../../organisms/AgriculturalStudies'
import TitleBar from '../../atoms/TitleBar'
import { FormattedMessage } from 'react-intl'
import { FaQuestionCircle, FaRegFile } from 'react-icons/fa'

const ContainerStatic = styled(Container)`
  padding-bottom: 4rem;
  margin-top: 6rem;
  padding-right: 25px !important;
  padding-left: 15px !important;
`

const LinkContainer = styled.div`
  display: flex;
`

const CustomLink = styled.a`
  color: ${({ theme }) => theme.colors.secondary};
  text-decoration: none;
  font-weight: bold;
  display: block;
  margin: 0 30px 25px 0;

  &:hover {
    color: ${({ theme }) => theme.colors.main};
    text-decoration: none;
    font-weight: bolder;
  }

  & > svg {
    margin-right: 10px;
    font-size: 20px;
  }
`

class Research extends Component {
  render () {
    return (
      <ContainerStatic fluid>
        <TitleBar>
          survey.messages.title
        </TitleBar>
        <LinkContainer>
          <CustomLink href="https://www.dropbox.com/sh/cvtrj35w6hzehhb/AAA3qEtmgwmQ1lN5bY2e5zYIa?dl=0&preview=Notas+T%C3%A9cnicas+-+Pesquisas+IBGE.DOCX" target="_blank" >
            <FaRegFile />
            <FormattedMessage id="survey.technote" />
          </CustomLink>
        </LinkContainer>  
        <AgriculturalStudies />
      </ContainerStatic>
    )
  }
}

export default Research



// WEBPACK FOOTER //
// ./src/components/templates/Research/Research.js